import { render, staticRenderFns } from "./DeleteArchiveDialogBox.vue?vue&type=template&id=079ce68a&scoped=true&"
import script from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ce68a",
  null
  
)

export default component.exports